import React from 'react';
import { CommonTable } from '../CommonTable';
import { organizationTopDelegatesTableHeaders, ORGANIZATION_TOP_DELEGATES_TABLE_PARAMS } from './constants/organization-top-delegates.constants';
import { DELEGATES_TAB_DESCRIPTIONS, DELEGATES_TAB } from '../../../../../../constants';

const mockDelegatesData = [
    {
        rank: 1,
        delegateAddress: '0x1234567890123456789012345678901234567890',
        ensName: {
            title: 'alice.eth',
            link: '/user/0x1234567890123456789012345678901234567890',
        },
        numberOfDelegators: 245,
        votingPower: 1250000,
        totalVotes: 89,
        votes1Year: 67,
        votes6Months: 45,
        votes3Months: 23,
        gScoreRank: 98,
    },
    {
        rank: 2,
        delegateAddress: '0x2345678901234567890123456789012345678901',
        ensName: {
            title: 'bob.eth',
            link: '/user/0x2345678901234567890123456789012345678901',
        },
        numberOfDelegators: 198,
        votingPower: 980000,
        totalVotes: 76,
        votes1Year: 58,
        votes6Months: 38,
        votes3Months: 19,
        gScoreRank: 87,
    },
    {
        rank: 3,
        delegateAddress: '0x3456789012345678901234567890123456789012',
        ensName: {
            title: 'charlie.eth',
            link: '/user/0x3456789012345678901234567890123456789012',
        },
        numberOfDelegators: 156,
        votingPower: 750000,
        totalVotes: 62,
        votes1Year: 45,
        votes6Months: 31,
        votes3Months: 16,
        gScoreRank: 76,
    },
    {
        rank: 4,
        delegateAddress: '0x4567890123456789012345678901234567890123',
        ensName: {
            title: 'diana.eth',
            link: '/user/0x4567890123456789012345678901234567890123',
        },
        numberOfDelegators: 134,
        votingPower: 620000,
        totalVotes: 54,
        votes1Year: 39,
        votes6Months: 26,
        votes3Months: 14,
        gScoreRank: 65,
    },
    {
        rank: 5,
        delegateAddress: '0x5678901234567890123456789012345678901234',
        ensName: {
            title: 'eve.eth',
            link: '/user/0x5678901234567890123456789012345678901234',
        },
        numberOfDelegators: 112,
        votingPower: 480000,
        totalVotes: 47,
        votes1Year: 34,
        votes6Months: 22,
        votes3Months: 12,
        gScoreRank: 54,
    },
    {
        rank: 6,
        delegateAddress: '0x6789012345678901234567890123456789012345',
        ensName: {
            title: 'frank.eth',
            link: '/user/0x6789012345678901234567890123456789012345',
        },
        numberOfDelegators: 89,
        votingPower: 350000,
        totalVotes: 38,
        votes1Year: 28,
        votes6Months: 18,
        votes3Months: 9,
        gScoreRank: 43,
    },
    {
        rank: 7,
        delegateAddress: '0x7890123456789012345678901234567890123456',
        ensName: {
            title: 'grace.eth',
            link: '/user/0x7890123456789012345678901234567890123456',
        },
        numberOfDelegators: 67,
        votingPower: 280000,
        totalVotes: 31,
        votes1Year: 23,
        votes6Months: 15,
        votes3Months: 8,
        gScoreRank: 32,
    },
    {
        rank: 8,
        delegateAddress: '0x8901234567890123456789012345678901234567',
        ensName: {
            title: 'henry.eth',
            link: '/user/0x8901234567890123456789012345678901234567',
        },
        numberOfDelegators: 45,
        votingPower: 220000,
        totalVotes: 25,
        votes1Year: 18,
        votes6Months: 12,
        votes3Months: 6,
        gScoreRank: 21,
    },
];

export const blurredDelegatesContent = (
    <CommonTable
        title="Top Delegates"
        infoText={DELEGATES_TAB_DESCRIPTIONS[DELEGATES_TAB.TOP_DELEGATES]}
        lastUpdate={'2023-12-15'}
        tableRowsData={mockDelegatesData}
        loading={false}
        tableHeaderData={organizationTopDelegatesTableHeaders}
        sortedParamName={ORGANIZATION_TOP_DELEGATES_TABLE_PARAMS.VOTING_POWER}
        isStretched
    />
); 